/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Own_Bot_Token_RejectedInputs */



/**
* | output |
* | --- |
* | "Discord rejected that token. Copy it fresh from the developer portal." |
*
* @param {Settings_Own_Bot_Token_RejectedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const settings_own_bot_token_rejected = /** @type {((inputs?: Settings_Own_Bot_Token_RejectedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Own_Bot_Token_RejectedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Discord отклонил этот токен. Скопируйте его заново из Developer Portal.")
	return /** @type {LocalizedString} */ ("Discord rejected that token. Copy it fresh from the developer portal.")
});